import config from 'config';
const { DASHBOARD_URL } = config;

import {
  StyledItemsEmpty,
  StyledEmpty,
  StyledEmptyLink,
  StyledEmptyText
} from 'components/grid-table/grid-table.style';

const ProjectsIsAny = () => {
  return (
    <StyledItemsEmpty>
      <StyledEmpty p={5}>
        <StyledEmptyText>
          You do not have any projects in this category.
        </StyledEmptyText>
        <StyledEmptyText>
          Please go to the{' '}
          <StyledEmptyLink target="_blank" href={DASHBOARD_URL}>
            PO Dashboard
          </StyledEmptyLink>{' '}
          to create a project.
        </StyledEmptyText>
      </StyledEmpty>
    </StyledItemsEmpty>
  );
};

export default ProjectsIsAny;
